import { Badge, Box, Collapse, Flex, Group, Text } from "@mantine/core";
import { IconChevronDown, IconChevronUp } from "@tabler/icons-react";
import { useState } from "react";
import NavbarSection from "./NavbarSection";

export default function NavbarItem({ title, isActive, icon, list, badge }) {
  const [opened, setOpened] = useState(false);

  return (
    <>
      <Group
        px={12}
        py={8}
        mb={5}
        position="apart"
        onClick={() => list && setOpened((o) => !o)}
        sx={(theme) => {
          const isDark = theme.colorScheme === "dark";
          const colors = theme.colors;
          return isActive
            ? {
                fontWeight: 500,
                borderRadius: theme.radius.sm,
                color: isDark ? theme.white : colors.brand[5],
                backgroundColor: theme.fn.variant({ variant: theme.colorScheme, color: theme.brand }).background,
              }
            : {
                cursor: "pointer",
                borderRadius: theme.radius.sm,
                color: isDark ? colors.gray[4] : colors.gray[7],
                backgroundColor: "transparent",
                "&:hover": {
                  backgroundColor: isDark ? colors.dark[4] : theme.colors.gray[0],
                  color: isDark ? theme.white : theme.black,
                },
              };
        }}
      >
        <Flex gap={10} align="center">
          {icon}
          <Text size="sm">{title}</Text>
        </Flex>

        <Flex gap={8} align="center">
          {badge !== undefined && badge > 0 && (
            <Badge size="sm" color="orange" variant="filled">
              {badge}
            </Badge>
          )}
          {list && opened && <IconChevronUp size={18} />}
          {list && !opened && <IconChevronDown size={18} />}
        </Flex>
      </Group>
      <Collapse in={opened}>
        {list &&
          list.map((item) => {
            return <NavbarSection {...item} key={item.title} />;
          })}
      </Collapse>
    </>
  );
}
